module.exports = __webpack_public_path__ + "static/340FFF_2_0-d1a66689cc5d134e582ed26ad40f23ac.woff2";